(function () {
    const activeClass = "deal-card-image-carousel__pip--active";

    function populateSlide(slide) {
        const image = slide?.querySelector("img");
        if (!image || image.dataset.carouselPopulated === "true") {
            return;
        }

        const source = image.dataset.src || image.getAttribute("src");
        const sourceSet = image.dataset.srcset || image.getAttribute("srcset");

        if (source && !image.getAttribute("src")) {
            image.setAttribute("src", source);
        }

        if (sourceSet && !image.getAttribute("srcset")) {
            image.setAttribute("srcset", sourceSet);
        }

        if (source || sourceSet) {
            image.dataset.carouselPopulated = "true";
        }
    }

    function updateCarousel(carousel, activeIndex, offset) {
        const slides = Array.from(carousel.querySelectorAll(".deal-card-image-carousel__slide"));
        const track = carousel.querySelector(".deal-card-image-carousel__track");
        const pips = Array.from(carousel.querySelectorAll(".deal-card-image-carousel__pips button"));

        if (!slides.length || !track) {
            return;
        }

        const nextIndex = (activeIndex + slides.length) % slides.length;

        carousel.dataset.activeIndex = String(nextIndex);
        track.style.transform = `translateX(calc(${-nextIndex * 100}% + ${offset}px))`;

        slides.forEach((slide, index) => {
            slide.tabIndex = index === nextIndex ? 0 : -1;
            slide.setAttribute("aria-hidden", index === nextIndex ? "false" : "true");
        });

        pips.forEach((pip, index) => {
            pip.classList.toggle(activeClass, index === nextIndex);
            if (index === nextIndex) {
                pip.setAttribute("aria-current", "true");
            } else {
                pip.removeAttribute("aria-current");
            }
        });
    }

    function initCarousel(carousel) {
        if (!carousel || carousel.dataset.specialOfferImageCarouselInitialised === "true") {
            return;
        }

        const slides = Array.from(carousel.querySelectorAll(".deal-card-image-carousel__slide"));
        const viewport = carousel.querySelector(".deal-card-image-carousel__viewport");
        const previousButton = carousel.querySelector(".deal-card-image-carousel__nav--previous");
        const nextButton = carousel.querySelector(".deal-card-image-carousel__nav--next");
        const pips = Array.from(carousel.querySelectorAll(".deal-card-image-carousel__pips button"));

        viewport.style.touchAction = "pan-y pinch-zoom";
        viewport.style.userSelect = "none";
        viewport.style.webkitUserSelect = "none";

        carousel.dataset.specialOfferImageCarouselInitialised = "true";

        if (slides.length <= 1 || !viewport) {
            updateCarousel(carousel, 0, 0);
            return;
        }

        let activeIndex = 0;
        let offset = 0;
        let pointerId;
        let startX = 0;
        let startY = 0;
        let dragging = false;
        let suppressClick = false;
        let gestureSource = null;

        function navigate(index) {
            activeIndex = (index + slides.length) % slides.length;
            populateSlide(slides[activeIndex]);
            offset = 0;
            updateCarousel(carousel, activeIndex, offset);
        }

        function beginGesture(source, clientX, clientY, id) {
            if (slides.length < 2) {
                return false;
            }

            gestureSource = source;
            pointerId = id;
            startX = clientX;
            startY = clientY;
            suppressClick = false;
            return true;
        }

        function applyGesture(source, clientX, clientY, event) {
            if (gestureSource !== source) {
                return;
            }

            const dx = clientX - startX;
            const dy = clientY - startY;

            if (!dragging) {
                if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
                    cancelDrag();
                    return;
                }

                if (Math.abs(dx) < 8) {
                    return;
                }

                dragging = true;
                suppressClick = true;
                viewport.classList.add("deal-card-image-carousel__viewport--dragging");

                if (source === "pointer") {
                    viewport.setPointerCapture?.(pointerId);
                }
            }

            const nextIndex = activeIndex + (dx < 0 ? 1 : -1);
            if (nextIndex >= 0 && nextIndex < slides.length) {
                populateSlide(slides[nextIndex]);
            }
            offset = nextIndex < 0 || nextIndex >= slides.length ? dx / 4 : dx;
            updateCarousel(carousel, activeIndex, offset);

            if (source === "touch" && event && typeof event.preventDefault === "function") {
                event.preventDefault();
            }
        }

        function endGesture(source, id) {
            if (gestureSource !== source) {
                return;
            }

            if (source === "pointer" && id !== pointerId) {
                return;
            }

            if (dragging && Math.abs(offset) > Math.min(60, (viewport.clientWidth || 300) * 0.2)) {
                navigate(Math.max(0, Math.min(slides.length - 1, activeIndex + (offset < 0 ? 1 : -1))));
                cancelDrag();
                return;
            }

            cancelDrag();
        }

        function cancelDrag() {
            const capturedPointerId = pointerId;
            pointerId = undefined;
            gestureSource = null;
            dragging = false;
            offset = 0;
            viewport.classList.remove("deal-card-image-carousel__viewport--dragging");

            if (capturedPointerId !== undefined && viewport.hasPointerCapture?.(capturedPointerId)) {
                viewport.releasePointerCapture(capturedPointerId);
            }

            updateCarousel(carousel, activeIndex, offset);
        }

        function startPointerDrag(event) {
            if (!event.isPrimary || event.button !== 0 || !beginGesture("pointer", event.clientX, event.clientY, event.pointerId)) {
                return;
            }
        }

        function movePointerDrag(event) {
            if (event.pointerId !== pointerId) {
                return;
            }

            applyGesture("pointer", event.clientX, event.clientY);
        }

        function endPointerDrag(event) {
            endGesture("pointer", event.pointerId);
        }

        function cancelPointerDrag() {
            if (gestureSource === "pointer") {
                cancelDrag();
            }
        }

        function startTouchDrag(event) {
            if (event.touches.length !== 1) {
                return;
            }

            const touch = event.touches[0];
            beginGesture("touch", touch.clientX, touch.clientY);
        }

        function moveTouchDrag(event) {
            if (gestureSource !== "touch" || event.touches.length !== 1) {
                return;
            }

            const touch = event.touches[0];
            applyGesture("touch", touch.clientX, touch.clientY, event);
        }

        function endTouchDrag() {
            endGesture("touch");
        }

        function cancelTouchDrag() {
            if (gestureSource === "touch") {
                cancelDrag();
            }
        }

        function guardClick(event) {
            if (!suppressClick || event.detail === 0) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            suppressClick = false;
        }

        populateSlide(slides[activeIndex]);
        updateCarousel(carousel, activeIndex, offset);

        previousButton?.addEventListener("click", (event) => {
            event.preventDefault();
            navigate(activeIndex - 1);
        });

        nextButton?.addEventListener("click", (event) => {
            event.preventDefault();
            navigate(activeIndex + 1);
        });

        pips.forEach((pip, index) => {
            pip.addEventListener("click", (event) => {
                event.preventDefault();
                navigate(index);
            });
        });

        viewport.addEventListener("pointerdown", startPointerDrag);
        viewport.addEventListener("pointermove", movePointerDrag);
        viewport.addEventListener("pointerup", endPointerDrag);
        viewport.addEventListener("pointercancel", cancelPointerDrag);
        viewport.addEventListener("lostpointercapture", cancelPointerDrag);
        viewport.addEventListener("touchstart", startTouchDrag);
        viewport.addEventListener("touchmove", moveTouchDrag);
        viewport.addEventListener("touchend", endTouchDrag);
        viewport.addEventListener("touchcancel", cancelTouchDrag);
        viewport.addEventListener("click", guardClick, true);
        viewport.addEventListener("dragstart", (event) => event.preventDefault());
        viewport.addEventListener("keydown", (event) => {
            if (event.key === "ArrowLeft") {
                event.preventDefault();
                navigate(activeIndex - 1);
            }

            if (event.key === "ArrowRight") {
                event.preventDefault();
                navigate(activeIndex + 1);
            }
        });
    }

    function initAll(root) {
        const scope = root || document;
        scope.querySelectorAll(".deal-card-image-carousel").forEach(initCarousel);
    }

    window.initializeSpecialOfferImageCarousels = initAll;

    document.addEventListener("DOMContentLoaded", () => initAll(document));
})();
